/* ============================================================
   Video de bienvenida · Daza Organic
   Abre el video en una capa a pantalla completa, formato reel.

   Notas de comportamiento:
   · El foco se lleva al diálogo y se devuelve al botón al cerrar.
   · Escape cierra; el foco queda atrapado dentro mientras está abierto.
   · Al cerrar se DETIENE el video: si no, sigue sonando de fondo.
   ============================================================ */
(function () {
  'use strict';

  function arranca(raiz) {
    if (raiz.dataset.vfListo) return;
    raiz.dataset.vfListo = '1';

    var disparador = raiz.querySelector('[data-vf-abrir]');
    var capa = raiz.querySelector('[data-vf-capa]');
    if (!disparador || !capa) return;

    var cerrar = capa.querySelector('[data-vf-cerrar]');
    var media = capa.querySelector('video, iframe');
    var srcOriginal = media && media.tagName === 'IFRAME' ? media.getAttribute('src') : null;
    var ultimoFoco = null;

    function focosVisibles() {
      return Array.prototype.filter.call(
        capa.querySelectorAll('button, [href], video[controls]'),
        function (el) { return el.offsetWidth > 0 || el.offsetHeight > 0; }
      );
    }

    function abre() {
      // Safari no enfoca los botones al pulsarlos, así que activeElement
      // puede ser <body>. En ese caso el destino de vuelta es el disparador.
      ultimoFoco = document.activeElement;
      if (!ultimoFoco || ultimoFoco === document.body) ultimoFoco = disparador;
      capa.hidden = false;
      // Bloquear el scroll de fondo: si no, la página se mueve detrás.
      document.body.style.overflow = 'hidden';
      raiz.dataset.vfAbierto = '';
      if (media && media.tagName === 'IFRAME' && srcOriginal) {
        media.setAttribute('src', srcOriginal + (srcOriginal.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1');
      } else if (media && media.play) {
        var p = media.play();
        if (p && p.catch) p.catch(function () { /* el navegador puede negar el autoplay con sonido */ });
      }
      if (cerrar) cerrar.focus();
    }

    function cierra() {
      capa.hidden = true;
      document.body.style.overflow = '';
      delete raiz.dataset.vfAbierto;
      if (media && media.tagName === 'IFRAME' && srcOriginal) {
        media.setAttribute('src', srcOriginal);   // corta la reproducción
      } else if (media && media.pause) {
        media.pause();
        try { media.currentTime = 0; } catch (e) { /* algunos formatos no dejan rebobinar */ }
      }
      if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
    }

    disparador.addEventListener('click', abre);
    if (cerrar) cerrar.addEventListener('click', cierra);
    capa.addEventListener('click', function (e) { if (e.target === capa) cierra(); });

    document.addEventListener('keydown', function (e) {
      if (capa.hidden) return;
      if (e.key === 'Escape') { cierra(); return; }
      if (e.key !== 'Tab') return;
      var f = focosVisibles();
      if (!f.length) return;
      var primero = f[0], ultimo = f[f.length - 1];
      if (e.shiftKey && document.activeElement === primero) { e.preventDefault(); ultimo.focus(); }
      else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primero.focus(); }
    });
  }

  function todos() { document.querySelectorAll('[data-daza-vf]').forEach(arranca); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todos);
  else todos();
  document.addEventListener('shopify:section:load', todos);
})();
